module.exports = __webpack_public_path__ + "img/main-data-ioc03.130ca594.png";